import { Card, CardContent } from "@/components/ui/card";
import FormPageHeading from "@/v2/components/ui/heading/FormPage";
import { BriefcaseBusinessIcon } from "lucide-react";
import ArProfileForm from "@/v2/components/pages/ar-profile/Form";

export default function CreateArProfile() {
    return (
        <div className="my-3 min-h-screen">
            <Card className="rounded-xl border-slate-200 shadow-lg dark:border-slate-700">
                <FormPageHeading
                    title={"Create Company Details"}
                    description="Create and manage your company information"
                    Icon={BriefcaseBusinessIcon}
                />
                <CardContent className="pt-6">
                    <ArProfileForm />
                </CardContent>
            </Card>
        </div>
    );
}
